import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Navbar from "./components/Navbar";
import AddTransaction from "./components/AddTransaction";
import AddEmi from "./components/AddEmi";
import { TransactionState } from "./Context/TransactionContext";
import PrivateRoute from "./components/PrivateRoute";
import MainLayout from "./components/MainLayout";
import UserProfile from "./components/UserProfile";
import TransactionDetail from "./components/TransactionDetail";
import { UserState } from "./Context/UserContext";
import FoodieNetwork from "./components/FoodieNetwork";
import OweGet from "./components/OweGet";
import ScrollToTop from "./components/ScrollToTop";
import FriendProfile from "./components/FriendProfile";
import Settings from "./components/Settings";
import BillingDashboard from "./components/BillingDashboard";
import QuickNav from "./components/QuickNav";
import { isTokenExpired } from "./utils/checkToken";

function App() {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) return;

    if (isTokenExpired(token)) {
      localStorage.removeItem("token");

      window.location.href = "/login";
    }
  }, []);

  // useEffect(() => {
  //   const handleBack = () => {
  //     const openModal = document.querySelector(".modal.show");

  //     if (!openModal) return;

  //     const modal = window.bootstrap.Modal.getOrCreateInstance(openModal);

  //     modal.hide();

  //     document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());

  //     document.body.classList.remove("modal-open");
  //     document.body.style.removeProperty("overflow");
  //     document.body.style.removeProperty("padding-right");
  //   };

  //   window.addEventListener("popstate", handleBack);

  //   return () => {
  //     window.removeEventListener("popstate", handleBack);
  //   };
  // }, []);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  };
  return (
    <TransactionState>
      <UserState>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route element={<PrivateRoute />}>
              <Route element={<MainLayout alert={alert} />}>
                <Route exact path="/" element={<Home />} />
                <Route
                  exact
                  path="/addTransaction"
                  element={<AddTransaction showAlert={showAlert} />}
                />
                <Route exact path="/UserProfile" element={<UserProfile />} />
                <Route
                  exact
                  path="/transactionDetail/:id"
                  element={<TransactionDetail showAlert={showAlert} />}
                />
                <Route
                  exact
                  path="/foodiesNetwork"
                  element={<FoodieNetwork />}
                />
                <Route exact path="/MoneyFlow" element={<OweGet />} />
                <Route exact path="/Settings" element={<Settings />} />
                <Route
                  exact
                  path="/emi"
                  element={<AddEmi showAlert={showAlert} />}
                />
                <Route
                  exact
                  path="/swiggyTracker"
                  element={<BillingDashboard />}
                />
                <Route
                  exact
                  path="/friendProfile/:id"
                  element={<FriendProfile />}
                />
              </Route>
            </Route>
          </Routes>
          <QuickNav />
        </Router>
      </UserState>
    </TransactionState>
  );
}

export default App;
